import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddCourse from "../components/AddCourse";

const AddCoursePage = () => {
  return (
    <>
     
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Course  </h5><Breadcrumb title="Add Course" /></div>


        {/* AddUserLayer */}
        <AddCourse />
      
    </>
  );
};

export default AddCoursePage;
